'use client';

import { useEffect, useState } from 'react';
import {
  TYPOGRAPHY_MODE,
  TYPOGRAPHY_MODE_ATTRIBUTE,
  type TypographyMode,
} from './typography-mode';

function readTypographyMode(): TypographyMode {
  if (typeof document === 'undefined') {
    return TYPOGRAPHY_MODE.PLATFORM;
  }

  return document.documentElement.getAttribute(TYPOGRAPHY_MODE_ATTRIBUTE) ===
    TYPOGRAPHY_MODE.TORCH
    ? TYPOGRAPHY_MODE.TORCH
    : TYPOGRAPHY_MODE.PLATFORM;
}

export function useTypographyMode(): TypographyMode {
  const [mode, setMode] = useState<TypographyMode>(TYPOGRAPHY_MODE.PLATFORM);

  useEffect(() => {
    const root = document.documentElement;
    const sync = () => setMode(readTypographyMode());

    sync();

    const observer = new MutationObserver(sync);

    observer.observe(root, {
      attributes: true,
      attributeFilter: [TYPOGRAPHY_MODE_ATTRIBUTE],
    });

    return () => observer.disconnect();
  }, []);

  return mode;
}
